export { default } from "./LoginHistory";
